import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import FilterTogglebar from "../common/FilterTogglebar";
import AgricultureView from "./AgricultureView";
import AgricultureViewResponsive from "./AgricultureViewResponsive";
// import { agriculture } from './constants';
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const AgricultureContainer = () => {
  const {
    loadWaterDeliveries,
    loadAgricultureDistrictWater,
    loadAgriculture,
    // loadAgricultureMetrics,
    setSelectedAgriculture,
    resetSelectedAgriculture,
    setWaterUserOption,
  } = userActions();
  const { agriculture, agriculture_selected, water_user_options, districts } =
    useSelector((state) => state.water_user);
  // const [scenario_disabled, setScenarioDisabled] = useState(false);
  const { isMobile } = useGetViewPortDimensions();

  const handleChange = (value) => {
    // loadAgricultureMetrics(value);//metrics will come from adriculture district water list
    setSelectedAgriculture(water_user_options[value - 1]); //the agriculture array index is 1 below the agriculture value
  };

  const componentMount = () => {
    loadAgriculture();
    loadAgricultureDistrictWater();
    loadWaterDeliveries();
    // loadAgricultureMetrics(1); //metrics will come from adriculture district water list
    return () => {
      resetSelectedAgriculture();
    };
  }

  useEffect(componentMount, []);

  const setWaterFunc = () => {
    setWaterUserOption(districts);
  }
  useEffect(setWaterFunc, [districts]);

  return (
    <Grid container>
      {!isMobile ? <FilterTogglebar
        title={`Water User: ${agriculture_selected.name}`}
        options={water_user_options || agriculture}
        handleChange={handleChange}
        value={agriculture_selected.agriculture_id}
        scenario_disabled={true}
      /> : null}
      {!isMobile ? (
        <AgricultureView
          // setScenarioDisabled={(disabled) => setScenarioDisabled(disabled)}
        />) : <AgricultureViewResponsive />}
    </Grid>
  );
};

export default AgricultureContainer;
